site.houses = {
	init: function() {
		site.houses.initFilter();

		site.owl.init('#houses .images', {
			items: 1,
			navText:'',
			nav:true,
			dots:false,
			mouseDrag:false,
			touchDrag:false,
			pullDrag:false
		});
	},

	initFilter: function() {
		var $grid = $('#houses .items').isotope({
				itemSelector: '.item',
				layoutMode: 'fitRows'
			}),

			activeFilters = [],

			getActiveFilters = function() {
				return activeFilters.join(', ');
			},
			addActiveFilter = function(filter) {
				activeFilters.push(filter);
			},
			removeActiveFilter = function(filter) {
				activeFilters = activeFilters.filter(function(e) { return e !== filter })
			};

		// layout Isotope after each image loads
		$grid.imagesLoaded().progress( function() {
			$grid.isotope('layout');
		});

		$('.buttons').on( 'click', 'button', function() {
			var $this = $(this);
			var filterValue = $this.attr('data-filter');
			if ($this.hasClass('selected') && !$this.hasClass('lowest')) {
				$this.siblings().removeClass('lowest');
				$this.addClass('selected lowest');
				$this.prevAll().each(function() {
					$(this).removeClass('selected');
					removeActiveFilter($(this).attr('data-filter'));
				});
			}
			else if (!$this.hasClass('lowest')) {
				$this.siblings().removeClass('lowest');
				$this.addClass('selected lowest');
				addActiveFilter(filterValue);
				$this.nextAll().each(function() {
					$(this).addClass('selected');
					addActiveFilter($(this).attr('data-filter'));
				});
			}
			else if ($this.hasClass('lowest')) {
				$this.removeClass('lowest');
				$this.parent().children().each(function() {
					$(this).removeClass('selected');
					removeActiveFilter($(this).attr('data-filter'));
				});
			}
			$this.blur();
			$grid.isotope({ filter: getActiveFilters() });
		});

		$('select', '.selectFilter').on('focus', function () {
			removeActiveFilter(this.value);
		}).change(function() {
			addActiveFilter(this.value);
			$grid.isotope({ filter: getActiveFilters() });
			$(this).blur();
		});

	}
};

site.employees = {
	init: function () {
		if ($('#employees .staff').length === 0) {
			return false;
		}

		//site.maxHeight.init('.employee .content');

		$('button.empExpand').on('click', function(e) {
			e.stopPropagation();
			var $this = $(this),
				$employee = $this.closest('.employee');
			$employee.siblings().removeClass('showContent');
			$employee.toggleClass('showContent');
		});

		$('.content', '.employee').on('click', function(e) {
			e.stopPropagation();
		});

		$('body').on('click', function() {
			$('.employee', '.staff').removeClass('showContent');
		});
	}
};

site.house = {
	view: function () {
		var $others = $('.box_other');
		$others.responsiveDom({
			appendTo: '#below .otherMobile',
			mediaQuery: 'screen and (max-width: 991px)',
		});
	}
};

site.frontpage = {
	init: function() {
		site.frontpage.newsCarousel();
		$(window).resize(function() {
			site.frontpage.newsCarousel();
		});
	},

	hasCarousel: false,

	newsCarousel: function() {
		var $body = $('body');
		if ($body.width() < 992) {

			if (!site.frontpage.hasCarousel) {
				site.owl.init('.news__entries', {
					responsive: {
						0: {
							items: 1
						},
						480: {
							items: 2
						}
					}
				});
				site.frontpage.hasCarousel = true;
			}
		}
		else {
			if (site.frontpage.hasCarousel) {
				$('.news__entries').owlCarousel('destroy').removeClass('owl-carousel');
				site.frontpage.hasCarousel = false;
			}
		}
	}
};